import { createFileRoute } from '@tanstack/react-router'
import { CreateRelationTypePage } from '../../../components/relation-types/CreateRelationTypePage'
import { PermissionDeniedState } from '../../../components/PermissionDeniedState'
import { useCan } from '../../../contexts/PermissionsContext'

export const Route = createFileRoute('/$org/relation-types/create')({
    component: CreateRelationType,
})

function CreateRelationType() {
    // The section's `read` guard let this caller in; creating needs `write`, so
    // a deep link to /create must not hand them a form that can only 403.
    const canWrite = useCan('configuration.write')
    if (!canWrite) return <PermissionDeniedState permission="configuration.write" />
    return <CreateRelationTypePage />
}
